var map = {
	"./1.jpg": "4FbQ",
	"./10.jpg": "5TwM",
	"./11.jpg": "OJZR",
	"./12.jpg": "+ccq",
	"./13.jpg": "y6Po",
	"./14.jpg": "6cHO",
	"./15.jpg": "rkeO",
	"./16.jpg": "nFc8",
	"./17.jpg": "5m14",
	"./18.jpg": "6/o2",
	"./19.jpg": "Iew8",
	"./2.jpg": "mwzy",
	"./20.jpg": "8Ahw",
	"./21.jpg": "K5F8",
	"./22.jpg": "e9hx",
	"./23.jpg": "yu04",
	"./24.jpg": "u2oZ",
	"./25.jpg": "r2u7",
	"./3.jpg": "zlMN",
	"./4.jpg": "6Msz",
	"./5.jpg": "HQDL",
	"./6.jpg": "KtLg",
	"./7.jpg": "Al16",
	"./8.jpg": "UijE",
	"./9.jpg": "IFO5",
	"./logo1.jpg": "EGg+",
	"./logo2.jpg": "UIpq",
	"./logo3.jpg": "gqz6"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "kWqk";


//////////////////
// WEBPACK FOOTER
// ./src/assets/globalPartner ^\.\/.*\.jpg$
// module id = kWqk
// module chunks = 0